module.exports = __webpack_public_path__ + "static/handbook_editor_600x412-07d928f6d89d2c02301840fbb04c62a8.jpg";